module.exports = __webpack_public_path__ + "static/media/herdy-working.11b519be.svg";